














import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CzChoice extends Vue {
  @Prop({ type: Boolean, default: false }) selected!: boolean;
  @Prop({ type: String, default: "" }) note!: string;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
}
